module.exports = __webpack_public_path__ + "img/avnon-2.43a51811.webp";